import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/components/AfterResultBot.css";
import "../styles/components/USScreeningPrograms.css";
import omnicareLogo from "../assets/icons/logo.svg";
import doctorImage from "../assets/images/doctor.png";
import backIcon from "../assets/icons/back.svg";
import LanguageSwitcher from "./LanguageSwitcher";

const USScreeningPrograms = () => {
  const navigate = useNavigate();

  const handleBookTest = (screeningType) => {
    navigate("/");
  };

  const handleBack = () => {
    navigate("/after-quiz/3");
  };

  const handleLearnMore = (screeningType) => {
    alert(`Learn more about ${screeningType} - this would show detailed information.`);
  };

  const handleTakeQuiz = () => {
    alert("Take quiz - this would open a health assessment quiz.");
  };

  return (
    <div className="after-result-bot-container">
      {/* Header */}
      <header className="after-result-bot-header">
        <div className="logo-section">
          <div className="logo" onClick={() => navigate("/landing")} style={{ cursor: 'pointer' }}>
            <img src={omnicareLogo} alt="Pebble Health Logo" className="logo-icon" />
            <span className="logo-text">Pebble Health</span>
          </div>
        </div>
        <div className="header-actions">
          <LanguageSwitcher />
          <div className="back-button" onClick={handleBack}>
            <img src={backIcon} alt="Back" className="back-icon" />
          </div>
        </div>
      </header>

      {/* Doctor illustration above divider */}
      <div className="doctor-divider">
        <img src={doctorImage} alt="Dr. Sam" className="doctor-avatar" />
      </div>

      <div className="us-programs-content">
        <h2 className="congrats-text">We Want Cancer Free!</h2>
        <h3 className="programs-subtitle">Programs in United States</h3>
        <p className="programs-description">
          Did you know that many cancer screening programs are available for free? Explore the options and book yours today!
        </p>

        <div className="screening-grid">
          {/* Breast Cancer Screening */}
          <div className="screening-section breast-cancer">
            <div className="screening-content">
              <h3 className="screening-title">Breast Cancer Screening</h3>
              <p className="screening-description">
                The USPSTF recommends biennial screening mammography for women aged <strong>40 to 74 years</strong>.
              </p>
              <p className="screening-description">
                Most health insurance plans are required to cover screening mammograms every <strong>1 to 2 years</strong> for eligible women.
              </p>
              <div className="screening-buttons">
                <button className="book-test-btn" onClick={() => handleBookTest("Breast Cancer")}>
                  Book a Test
                </button>
                <button className="learn-more-btn" onClick={() => handleLearnMore("Breast Cancer")}>
                  Learn More
                </button>
              </div>
            </div>
          </div>

          {/* Colorectal Cancer Screening */}
          <div className="screening-section colorectal-cancer">
            <div className="screening-content">
              <h3 className="screening-title">Colorectal Cancer Screening</h3>
              <p className="screening-description">
                Most people should begin screening for colorectal cancer soon after turning <strong>45</strong>.
              </p>
              <div className="screening-buttons">
                <button className="book-test-btn" onClick={() => handleBookTest("Colorectal Cancer")}>
                  Book a Test
                </button>
                <button className="learn-more-btn" onClick={() => handleLearnMore("Colorectal Cancer")}>
                  Learn More
                </button>
              </div>
            </div>
          </div>

          {/* Cervical Cancer Screening */}
          <div className="screening-section cervical-cancer">
            <div className="screening-content">
              <h3 className="screening-title">National Cervical Screening Program</h3>
              <p className="screening-description">
                Women and people with a cervix aged <strong>21 to 64 years</strong> of age are eligible for free screenings if not covered by their insurance.
              </p>
              <div className="screening-buttons">
                <button className="book-test-btn" onClick={() => handleBookTest("Cervical Cancer")}>
                  Book a Test
                </button>
                <button className="learn-more-btn" onClick={() => handleLearnMore("Cervical Cancer")}>
                  Learn More
                </button>
              </div>
            </div>
          </div>

          {/* Lung Cancer Screening */}
          <div className="screening-section lung-cancer">
            <div className="screening-content">
              <h3 className="screening-title">Lung Cancer Screening</h3>
              <p className="screening-description">
                You should get a LDCT if you have a <strong>20 pack-year or more</strong> smoking history, currently smoke or quit within the past <strong>15 years</strong>, and are over <strong>50</strong>.
              </p>
              <div className="screening-buttons">
                <button className="book-test-btn" onClick={() => handleBookTest("Lung Cancer")}>
                  Book a Test
                </button>
                <button className="learn-more-btn" onClick={() => handleLearnMore("Lung Cancer")}>
                  Learn More
                </button>
              </div>
            </div>
          </div>

          {/* Other Screenings */}
          <div className="screening-section other-screenings">
            <div className="screening-content">
              <h3 className="screening-title">Other Screenings: Hypertension, Diabetes, and Hyperlipidemia</h3>
              <p className="screening-description">
                These issues often develop silently but can lead to long-term health risks if left untreated. Take the quick quiz now to see if you should get screened. A few minutes could make a big difference.
              </p>
              <div className="screening-buttons">
                <button className="book-test-btn" onClick={() => handleBookTest("Other Screenings")}>
                  Book a Test
                </button>
                <button className="learn-more-btn" onClick={handleTakeQuiz}>
                  Take a Quiz
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default USScreeningPrograms;
